import { Box, Modal, Typography } from "@mui/material";
import { ShortBlueButton } from "../assets/style";

const containerStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '500px',
    height: '250px',
    background: '#E9F5FF',
    borderRadius: '30px'
}

const textContainerStyle = {
    marginTop: '35px',
    marginLeft: 'auto',
    marginRight: 'auto',
    paddingTop: '20px',
    paddingLeft: '25px',
    width: '450px',
    height: '140px',
    background: 'rgba(255, 255, 255, 0.8)',
    boxShadow: '0px 4px 4px #FFFFFF',
    borderRadius: '30px',
}

const typographyStyle = {
    fontFamily: 'Faune',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '18px'
}

const buttonsContainerStyle = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: '23px',
    paddingLeft: '125px',
    paddingRight: '125px'
}

const ModalConfirmationBox = function ({ description, open, onClose, onConfirm }: { description: string, open: boolean, onClose: any, onConfirm: any }) {
    return (
        <Modal
            open={open}
            onClose={onClose}
        >
            <Box sx={containerStyle}>
                <Box sx={textContainerStyle}>
                    <Typography sx={typographyStyle}>
                        {description}
                    </Typography>
                </Box>
                <Box sx={buttonsContainerStyle}>
                    <ShortBlueButton sx={{ margin: '0!important' }} onClick={onConfirm}>Yes</ShortBlueButton>
                    <ShortBlueButton sx={{ margin: '0 0 0 50px!important' }} onClick={onClose}>No</ShortBlueButton>
                </Box>

            </Box>
        </Modal>
    )
}

export default ModalConfirmationBox;